import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Routes from './../Shared/routes';
import ManagerApi from '../Api/account';

interface IProps {
    children: any;
    account: any;
}

interface IState {
    expanded: any;
}

class Container extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            expanded: null,
        };
    }
    async click(expanded: any) {
        if (this.state.expanded === expanded) expanded = null;
        this.setState({
            expanded,
        });
    }

    logout = async () => {
        await ManagerApi.logout();

    }

    onManagerCreate() {

    }

    render() {
        const { children } = this.props;
        return (<>
            <header className="app-header"><a className="app-header__logo" href="index.html">Avtodel</a>
                <a className="app-sidebar__toggle" href="#" data-toggle="sidebar" aria-label="Hide Sidebar"></a>
                <ul className="app-nav">
                    {/* <li className="app-search">
                        <input className="app-search__input" type="search" placeholder="Search" />
                        <button className="app-search__button"><i className="fa fa-search"></i></button>
                    </li>
                    <li className="dropdown"><a className="app-nav__item" href="#" data-toggle="dropdown" aria-label="Show notifications"><i className="fa fa-bell-o fa-lg"></i></a>
                        <ul className="app-notification dropdown-menu dropdown-menu-right">
                            <li className="app-notification__title">You have 4 new notifications.</li>
                            <div className="app-notification__content">
                                <li><a className="app-notification__item" href="javascript:;"><span className="app-notification__icon"><span className="fa-stack fa-lg"><i className="fa fa-circle fa-stack-2x text-primary"></i><i className="fa fa-envelope fa-stack-1x fa-inverse"></i></span></span>
                                    <div>
                                        <p className="app-notification__message">Lisa sent you a mail</p>
                                        <p className="app-notification__meta">2 min ago</p>
                                    </div></a></li>
                                <li><a className="app-notification__item" href="javascript:;"><span className="app-notification__icon"><span className="fa-stack fa-lg"><i className="fa fa-circle fa-stack-2x text-danger"></i><i className="fa fa-hdd-o fa-stack-1x fa-inverse"></i></span></span>
                                    <div>
                                        <p className="app-notification__message">Mail server not working</p>
                                        <p className="app-notification__meta">5 min ago</p>
                                    </div></a></li>
                                <li><a className="app-notification__item" href="javascript:;"><span className="app-notification__icon"><span className="fa-stack fa-lg"><i className="fa fa-circle fa-stack-2x text-success"></i><i className="fa fa-money fa-stack-1x fa-inverse"></i></span></span>
                                    <div>
                                        <p className="app-notification__message">Transaction complete</p>
                                        <p className="app-notification__meta">2 days ago</p>
                                    </div></a></li>
                                <div className="app-notification__content">
                                    <li><a className="app-notification__item" href="javascript:;"><span className="app-notification__icon"><span className="fa-stack fa-lg"><i className="fa fa-circle fa-stack-2x text-primary"></i><i className="fa fa-envelope fa-stack-1x fa-inverse"></i></span></span>
                                        <div>
                                            <p className="app-notification__message">Lisa sent you a mail</p>
                                            <p className="app-notification__meta">2 min ago</p>
                                        </div></a></li>
                                    <li><a className="app-notification__item" href="javascript:;"><span className="app-notification__icon"><span className="fa-stack fa-lg"><i className="fa fa-circle fa-stack-2x text-danger"></i><i className="fa fa-hdd-o fa-stack-1x fa-inverse"></i></span></span>
                                        <div>
                                            <p className="app-notification__message">Mail server not working</p>
                                            <p className="app-notification__meta">5 min ago</p>
                                        </div></a></li>
                                    <li><a className="app-notification__item" href="javascript:;"><span className="app-notification__icon"><span className="fa-stack fa-lg"><i className="fa fa-circle fa-stack-2x text-success"></i><i className="fa fa-money fa-stack-1x fa-inverse"></i></span></span>
                                        <div>
                                            <p className="app-notification__message">Transaction complete</p>
                                            <p className="app-notification__meta">2 days ago</p>
                                        </div></a></li>
                                </div>
                            </div>
                            <li className="app-notification__footer"><a href="#">See all notifications.</a></li>
                        </ul>
                    </li> */}
                    {/* <li className="dropdown"><a className="app-nav__item" onClick={this.logout} data-toggle="dropdown" aria-label="Open Profile Menu"><i className="fa fa-user fa-lg"></i></a>
                        <ul className="dropdown-menu settings-menu dropdown-menu-right">
                            <li><a className="dropdown-item" href="page-user.html"><i className="fa fa-cog fa-lg"></i> Settings</a></li>
                            <li><a className="dropdown-item" href="page-user.html"><i className="fa fa-user fa-lg"></i> Profile</a></li>
                           
                        </ul>
                    </li> */}
                    <li className="dropdown"><a className="app-nav__item" onClick={this.logout}  ><i className="fa fa-sign-out fa-lg"></i> Logout</a></li>
                </ul>
            </header>
            <div className="app-sidebar__overlay" data-toggle="sidebar"></div>
            <aside className="app-sidebar">
                <div className="app-sidebar__user">
                    {/* <img className="app-sidebar__user-avatar" src="https://s3.amazonaws.com/uifaces/faces/twitter/jsa/48.jpg" alt="User Image" /> */}
                    <div>
                        <p className="app-sidebar__user-name">{this.props.account?.firstName} {this.props.account?.lastName}</p>
                        {/* <p className="app-sidebar__user-designation">Frontend Developer</p> */}
                    </div>
                </div>
                <ul className="app-menu">
                    {/* <li><a className="app-menu__item active" href="dashboard.html">
                        <i className="app-menu__icon fa fa-dashboard"></i><span className="app-menu__label">Dashboard</span></a></li> */}
                    <li className={this.state.expanded === 'admin' ? 'treeview is-expanded' : 'treeview'}><a onClick={() => this.click('admin')} className="app-menu__item" href="#" data-toggle="treeview">
                        <i className="app-menu__icon fa fa-th-list"></i>
                        <span className="app-menu__label">Администраторы</span><i className="treeview-indicator fa fa-angle-right"></i></a>
                        <ul className="treeview-menu">
                            <li><Link
                                className="treeview-item"
                                to={Routes.ADMIN_CREATE}
                            ><i className="icon fa fa-circle-o"></i> Добавить</Link></li>
                            <li><Link
                                className="treeview-item"
                                to={Routes.ADMIN_LIST}
                            ><i className="icon fa fa-circle-o"></i> Список</Link></li>
                        </ul>
                    </li>
                    {/* <li className={this.state.expanded === 'organization' ? 'treeview is-expanded' : 'treeview'}><a onClick={() => this.click('organization')} className="app-menu__item" href="#" data-toggle="treeview">
                        <i className="app-menu__icon fa fa-th-list"></i>
                        <span className="app-menu__label">Организации</span><i className="treeview-indicator fa fa-angle-right"></i></a>
                        <ul className="treeview-menu">
                            <li><Link
                                className="treeview-item"
                                to={Routes.ORGANIZATION_CREATE}
                            ><i className="icon fa fa-circle-o"></i> Добавить</Link></li>
                            <li><Link
                                className="treeview-item"
                                to={Routes.ORGANIZATION_LIST}
                            ><i className="icon fa fa-circle-o"></i> Список</Link></li>
                        </ul>
                    </li> */}
                    <li className={this.state.expanded === 'channel' ? 'treeview is-expanded' : 'treeview'}><a onClick={() => this.click('channel')} className="app-menu__item" href="#" data-toggle="treeview">
                        <i className="app-menu__icon fa fa-th-list"></i>
                        <span className="app-menu__label">Каналы</span><i className="treeview-indicator fa fa-angle-right"></i></a>
                        <ul className="treeview-menu">
                            <li><Link
                                className="treeview-item"
                                to={Routes.CHANNEL_CREATE}
                            ><i className="icon fa fa-circle-o"></i> Добавить</Link></li>
                            <li><Link
                                className="treeview-item"
                                to={Routes.CHANNEL_LIST}
                            ><i className="icon fa fa-circle-o"></i> Список</Link></li>
                        </ul>
                    </li>
                    <li className={this.state.expanded === 'employee' ? 'treeview is-expanded' : 'treeview'}><a onClick={() => this.click('employee')} className="app-menu__item" href="#" data-toggle="treeview">
                        <i className="app-menu__icon fa fa-th-list"></i>
                        <span className="app-menu__label">Операторы</span><i className="treeview-indicator fa fa-angle-right"></i></a>
                        <ul className="treeview-menu">
                            <li><Link
                                className="treeview-item"
                                to={Routes.EMPLOYEE_CREATE}
                            ><i className="icon fa fa-circle-o"></i> Добавить</Link></li>
                            <li><Link
                                className="treeview-item"
                                to={Routes.EMPLOYEE_LIST}
                            ><i className="icon fa fa-circle-o"></i> Список</Link></li>
                        </ul>
                    </li>
                    <li className={this.state.expanded === 'log' ? 'treeview is-expanded' : 'treeview'}><a onClick={() => this.click('log')} className="app-menu__item" href="#" data-toggle="treeview">
                        <i className="app-menu__icon fa fa-th-list"></i>
                        <span className="app-menu__label">Лог</span><i className="treeview-indicator fa fa-angle-right"></i></a>
                        <ul className="treeview-menu">
                            <li><Link
                                className="treeview-item"
                                to={Routes.EVENT_LOG}
                            ><i className="icon fa fa-circle-o"></i> События</Link></li>
                            <li><Link
                                className="treeview-item"
                                to={Routes.ERROR_LOG}
                            ><i className="icon fa fa-circle-o"></i> Ошибки</Link></li>
                        </ul>
                    </li>
                </ul>
            </aside>
            <main className="app-content">
                {children}
            </main>
        </>
        );
    }
}


function bindAction(dispatch: any) {
    return {
    };
}

const mapStateToProps = (state: any) => {
    return {
        account: state.admin.current
    }
}

export default connect(
    mapStateToProps,
    bindAction
)(Container);
